import { createItemStorage } from "./createItemStorage";

export const billingInfo = ({ storage }) =>
	createItemStorage(storage, "billingInfo");
